import React, { useEffect, useState } from 'react';
import { Problem, Step } from '../solver/types';
import MatrixGrid from './MatrixGrid';

interface Props {
  title: string;
  problem: Problem;
  steps: Step[];
  totalCost: number;
  accent: string;
}

// Visor con navegación paso a paso de un método.
const StepViewer: React.FC<Props> = ({ title, problem, steps, totalCost, accent }) => {
  const [idx, setIdx] = useState(0);

  // Si cambian los pasos (nuevo cálculo), reiniciamos al primero.
  useEffect(() => {
    setIdx(0);
  }, [steps]);

  if (steps.length === 0) return null;
  const step = steps[Math.min(idx, steps.length - 1)];
  const cur = Math.min(idx, steps.length - 1);

  return (
    <div className="viewer" style={{ ['--accent' as any]: accent }}>
      <div className="viewer-head">
        <h3>{title}</h3>
        <span className="cost-badge">Costo: {totalCost}</span>
      </div>

      <MatrixGrid problem={problem} step={step} />

      <div className="step-info">
        <strong>{step.title}</strong>
        <p>{step.description}</p>
        {step.equations && step.equations.length > 0 && (
          <details className="equations" open>
            <summary>Ecuaciones del paso</summary>
            <ul>
              {step.equations.map((eq, k) =>
                eq.endsWith(':') ? (
                  <li key={k} className="eq-head">
                    {eq}
                  </li>
                ) : (
                  <li key={k}>{eq}</li>
                )
              )}
            </ul>
          </details>
        )}
      </div>

      <div className="nav">
        <button onClick={() => setIdx(0)} disabled={cur === 0}>
          « Inicio
        </button>
        <button onClick={() => setIdx((i) => Math.max(0, i - 1))} disabled={cur === 0}>
          ‹ Anterior
        </button>
        <span className="counter">
          {cur + 1} / {steps.length}
        </span>
        <button
          onClick={() => setIdx((i) => Math.min(steps.length - 1, i + 1))}
          disabled={cur === steps.length - 1}
        >
          Siguiente ›
        </button>
        <button onClick={() => setIdx(steps.length - 1)} disabled={cur === steps.length - 1}>
          Final »
        </button>
      </div>
    </div>
  );
};

export default StepViewer;
